<template>
  <div
    class="shop-by-school-nav"
    @mouseleave="handleExit"
  >
    <div v-if="schools">
      <div :class="$blockClass('shop-by-school-nav', 'letters-filter')">
        <nav>
          <ul>
            <li
              v-for="letter in alphabet"
              :key="letter"
              :class="{
                'active': currentLetter === letter,
                'disabled': !schoolByLetter[letter]
              }"
              :style="{'width': schoolLetterNavWidthDesktop + 'px'}"
              @mouseover="filterLetter(letter)">
              <strong>{{ letter.toUpperCase() }}</strong>
            </li>
          </ul>
        </nav>
      </div>
      <div class="shop-by-school-nav__school-list">
        <div
          v-for="(letter) in shownLetters" :key="'col-' + letter"
          :class="currentLetter === letter ? 'active' : ''"
          class="shop-by-school-nav__school-col"
          @mouseover="filterLetter(letter)"
        >
          <p class="letter-title"><strong>{{ letter.toUpperCase() }}</strong></p>
          <ul>
            <li v-for="school in schoolByLetter[letter]" :key="'school-list-' + school[schoolsNameCol]">
              <a :href="school[schoolsLinkCol] ? school[schoolsLinkCol] : '#'" @click="onLinkClick()">
                <span>
                  <img
                    v-if="school[schoolsLogoCol]?.length"
                    class="shop-by-school-nav__school-logo"
                    :src="school[schoolsLogoCol]"
                    alt=""
                  />
                  {{ school[schoolsNameCol] }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="schoolsNotFoundLink && schoolsNotFoundLink.length > 0"
        class="shop-by-school-nav__cta-block"
      >
        <a :href="schoolsNotFoundLink">{{ schoolsNotFoundLabel }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';


/**
 * Vue: Shop by School Nav (shop-by-school-nav)
 * -----------------------------------------------------------------------------
 * A large navigation for desktop that shows schools.
 */

const ALPHABET = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

export default {
  name: 'ShopBySchoolNav',
  props: {
    schools: {
      type: Array,
      required: true,
    },
    scrollElement: {
      type: HTMLElement,
      default: null,
    },
    schoolsNameCol: {
      type: String,
      default: '',
    },
    schoolsLetterCol: {
      type: String,
      default: '',
    },
    schoolsLogoCol: {
      type: String,
      default: '',
    },
    schoolsLinkCol: {
      type: String,
      default: '',
    },
    schoolLetterNavWidthDesktop: {
      type: Number,
      default: 32,
    },
    schoolsNotFoundLabel: {
      type: String,
      required: false,
      default: "",
    },
    schoolsNotFoundLink: {
      type: String,
      required: false,
      default: "",
    },
  },

  data: () => ({
    alphabet: ALPHABET,
    currentLetter: "a",
  }),

  computed: {

    /**
     * Returns object with schools grouped by Letter
     */
    schoolByLetter() {
      if (!this.schools) return ({})

      const dict = this.schools.reduce((acc, s) => {
        const letter = s[this.schoolsLetterCol].toLowerCase()
        if (!acc[letter]) {
          acc[letter] = []
        }
        acc[letter].push(s)
        return acc
      }, {})
      return dict
    },

    /**
     * List of letters shown
     */
    shownLetters() {
      const idx = this.alphabet.findIndex(x => x === this.currentLetter)
      const firstIndex = idx - (idx % 4)
      const secondIndex = Math.min((idx + 4) - ((idx + 4) % 4), this.alphabet.length) - 1
      const list = []
      for (let i = firstIndex; i <= secondIndex; i++) {
        list.push(this.alphabet[i])
      }
      return list

    },
  },

  watch: {

    /**
     * Watch isMobile to close on change.
     */
    isMobile() {
      if (this.isMobile) {
        return
      }

      this.closeOverlay('shopBySchoolNav')
    },
  },

  methods: {
    filterLetter(letter) {
      this.currentLetter = letter
    },

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    handleExit(event) {
      if (
        event.offsetY > 0 &&
        event.offsetX > 0 &&
        event.offsetX < this.scrollElement.clientWidth
      ) {
        this.closeOverlay('shopBySchoolNav')
      }
    },

    onLinkClick() {
      this.closeOverlay('shopBySchoolNav')
    },
  },



}
</script>
